import { ElaboratedTicketGroup } from 'types';
import { StoreType } from '@tock/shared/utils/connect';
import { calendarTicketGroupsSelector } from './ticketGroupsByDateTimeSelector';
import { createSelector } from 'reselect';
import { forEach, isEmpty, join, map, union } from 'es-toolkit/compat';
import createCachedSelector from 're-reselect';

export const ticketTypesByTableIdSelector = createSelector(
  calendarTicketGroupsSelector,
  (ticketGroups: ElaboratedTicketGroup[]) => {
    const tableIdToTicketTypeIds: Dictionary<number[]> = {};
    forEach(ticketGroups, (ticketGroup: ElaboratedTicketGroup) => {
      const ticketTypeIds = map(ticketGroup.ticketType, 'id') as number[];
      forEach(ticketGroup.tableId, (tableId: number) => {
        if (!tableIdToTicketTypeIds[tableId]) {
          tableIdToTicketTypeIds[tableId] = ticketTypeIds;
        } else {
          tableIdToTicketTypeIds[tableId] = union(tableIdToTicketTypeIds[tableId], ticketTypeIds);
        }
      });
    });
    return tableIdToTicketTypeIds;
  }
);

export const ticketTypesForTableIdSelector = createCachedSelector(
  ticketTypesByTableIdSelector,
  (state: StoreType, tableIds: number[]): number[] => tableIds,
  (ticketTypesByTableId: Dictionary<number[]>, tableIds: number[]): number[] => {
    let ticketTypeIds: number[] = [];
    if (isEmpty(tableIds)) {
      return [];
    }
    forEach(tableIds, (tableId: number) => {
      ticketTypeIds = union(ticketTypeIds, ticketTypesByTableId[tableId]);
    });

    return ticketTypeIds;
  }
)((state: StoreType, tableIds?: number[]) => `_${join(tableIds, '')}`);
